import { useEffect, useState } from 'react';
import { Box, Button, Flex, Link, Text, Image } from '@chakra-ui/react';
import { Link as LinkRouter } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ThemeToggle } from '../ThemeToggle';
import { AlterarSenhaModal } from '../AlterarSenhaModal';
import {
  baixarLogoEmpresa,
  lerVersaoLogo,
  liberarLogo,
  ouvirLogoAtualizada,
  recortarTransparencia,
} from '../../helpers/logoEmpresa';
import { RiLockPasswordLine } from 'react-icons/ri';
import logo from '../../assets/logo-arvore.png';

export const Header = () => {
  const { signOut, user } = useAuth();

  // Logomarca da empresa logada, servida pela API a partir do arquivo enviado
  // na Parametrização — trocar a logo lá troca aqui na hora.
  const empresaId = user?.empresa?.id;
  const [versaoLogo, setVersaoLogo] = useState(lerVersaoLogo);
  const [srcLogoEmpresa, setSrcLogoEmpresa] = useState('');
  const [alterandoSenha, setAlterandoSenha] = useState(false);

  useEffect(() => ouvirLogoAtualizada(() => setVersaoLogo(lerVersaoLogo())), []);

  // Baixa a logo (pelo axios, com token — ver baixarLogoEmpresa) e recorta a
  // moldura transparente do arquivo enviado, para as duas marcas ficarem na
  // mesma linha e altura. Empresa sem logo cadastrada devolve '': aí escondemos
  // imagem + divisória e fica só a marca essencial.
  useEffect(() => {
    let ativo = true;
    let baixada = '';

    setSrcLogoEmpresa('');

    baixarLogoEmpresa(empresaId, versaoLogo).then(async (url) => {
      baixada = url;

      // Desmontou (ou trocou a empresa/versão) enquanto baixava: o object URL
      // desta resposta não vai ser usado por ninguém, então some com ele aqui
      // mesmo — o cleanup abaixo já rodou e não tem como saber dele.
      if (!ativo) {
        liberarLogo(url);
        return;
      }

      if (!url) return;

      const recortada = await recortarTransparencia(url);
      if (!ativo) return;

      setSrcLogoEmpresa(recortada);

      // Quando houve recorte de verdade o retorno é um data URL, e o blob
      // baixado não é mais usado por ninguém — libera já em vez de esperar o
      // cleanup. Se voltou a própria URL (nada a recortar), ela ainda está na
      // tela e só pode ser liberada no cleanup.
      if (recortada !== url) {
        liberarLogo(url);
        baixada = '';
      }
    });

    return () => {
      ativo = false;
      liberarLogo(baixada);
    };
  }, [empresaId, versaoLogo]);

  return (
    <>
      <Flex
        as="header"
        w="100%"
        h="20"
        mx="auto"
        align="center"
        bgColor="gray.900"
        zIndex="60"
        pos="fixed"
        top="0"
      >
        <Flex
          zIndex="60"
          bgColor="gray.900"
          pl="66px"
          pr="6"
          mx="auto"
          w="100%"
          align="center"
        >
          {/* As duas marcas (empresa + essencial) formam um único atalho para a
              página inicial, que é a lista de pedidos (/home). Vira um <a> de
              verdade via LinkRouter — mesmo padrão da Sidebar —, então ganha
              teclado e "abrir em nova aba" de graça, sem onClick manual. */}
          <Link
            as={LinkRouter}
            to="/home"
            display="flex"
            alignItems="center"
            aria-label="Ir para a página inicial"
            _hover={{ textDecoration: 'none', opacity: 0.8 }}
            transition="opacity 0.2s"
          >
            {!!srcLogoEmpresa && (
              <>
                <Image
                  h="42px"
                  maxW="140px"
                  src={srcLogoEmpresa}
                  alt="Logo da empresa"
                  objectFit="contain"
                />
                <Box
                  w="1px"
                  h="28px"
                  mx="4"
                  bg="gray.600"
                  borderRadius="full"
                  flexShrink={0}
                />
              </>
            )}

            {/* Logo + nome agrupados no canto esquerdo */}
            <Flex align="center">
              <Image
                mr="2"
                boxSize="42px"
                src={logo}
                alt="Logo essencial"
                objectFit="contain"
              />
              <Text fontFamily="kallisto" fontSize="xl" fontWeight="bold" lineHeight="1">
                essencial
                <Text
                  as="span"
                  fontFamily="kallisto"
                  fontSize="sm"
                  ml="2"
                  color="orange.200"
                >
                  Sales Force
                </Text>
              </Text>
            </Flex>
          </Link>

          <Flex ml="auto" justify="center" align="center">
            <ThemeToggle />
            <Text mr="3" ml="3">
              Olá, {user.name}!
            </Text>
            <Button
              size="sm"
              mr="2"
              variant="ghost"
              leftIcon={<RiLockPasswordLine />}
              _hover={{ bg: 'gray.700' }}
              _active={{ bg: 'gray.600' }}
              onClick={() => setAlterandoSenha(true)}
            >
              Alterar senha
            </Button>
            <Button
              size="sm"
              bg="blue.500"
              color="white"
              _hover={{
                bg: 'blue.700',
              }}
              onClick={signOut}
            >
              Sair
            </Button>
          </Flex>
        </Flex>
      </Flex>

      {alterandoSenha && (
        <AlterarSenhaModal onClose={() => setAlterandoSenha(false)} />
      )}
    </>
  );
};
